import { render, staticRenderFns } from "./TablePageContainer.vue?vue&type=template&id=4e47fcf9&"
import script from "./TablePageContainer.vue?vue&type=script&lang=js&"
export * from "./TablePageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports